import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StoreX, { store } from "../../redux/oldStore";
import {
  ParticipantRequirement,
  RequirementInputType,
  UiFormData,
} from "../../utils/CommonTypes/UserTypes";
import { Server, ServerResponse } from "../../utils/Server";
import { IState, ReduxMap } from "../../redux/redux";
import Icon, { IconType } from "../../Components/Icon/Icon";
import NhdMedicalForm from "../../Components/User/NhdMedicalForm";

interface IProps extends IState {

}

const MedicalPage = (props: IProps) => {
  const navigate = useNavigate();
  
  const {userId} = useParams();
  const [formData, setFormData] = useState<UiFormData>();
  const [requirements, setRequirements] = useState<ParticipantRequirement[]>(
    []
  );
  const [formValues, setFormValues] = useState<Record<string, string>>({});
  const [requiredMissing, setRequiredMissing] = useState(false);

  useEffect(() => {
    
  }, []);

  useEffect(() => {
    if(formData?.Requirements && formData.Requirements.length > 0){
      return;
    }
    if (formData && formData.NewRecord && formData.NextRecordPath) {
      navigate(`${formData?.NextRecordPath}/${window.location.search}`);
    }
  }, [requirements, formData]);

 

  return (
    <div className="user-requirements-container">
        {userId && <NhdMedicalForm
         canSave={true}
         isFristTimeLogin={true}
         isNewUser={true}
         recordExists={false}
         personId={userId}
         onContinue={()=>{
            //go to next page in this mess...
            window.location.href = StoreX.BuildUrl(`../app/store/${userId}`);
         }}
        />}
    </div>
  );
};

export default ReduxMap(MedicalPage);
